/* Nordic Floor — forsiden (Fase B, T8).
   Hero-rotator, scroll-avsløring og telleverk. Alt slås av når
   brukeren har bedt om redusert bevegelse. */
(function () {
  'use strict';

  /* Hver forsideseksjon ber om denne filen, og nettleseren kjører hvert
     script-element for seg — på forsiden blir det fem ganger. Uten denne
     vakten får vi fem IntersectionObservere over de samme elementene og
     fem section:load-lyttere. Init-vaktene per element hindrer dobbel
     oppkobling, men ikke det dupliserte arbeidet. */
  if (window.__nfForsideLastet) return;
  window.__nfForsideLastet = true;

  var rolig = window.matchMedia
    ? window.matchMedia('(prefers-reduced-motion: reduce)').matches
    : false;

  /* ---------- Felles pausevalg for all automatisk bevegelse ----------
     Klassen på <html> stopper ticker, dekorstripe, Ken Burns og
     progresjonsstrekene via CSS; hero-rotatoren leser den i start().
     Valget lagres, så det står til brukeren selv endrer det. */
  var LAGER_NOKKEL = 'nf-bevegelse';

  function lagret() {
    try { return window.localStorage.getItem(LAGER_NOKKEL); } catch (e) { return null; }
  }
  function lagre(verdi) {
    try { window.localStorage.setItem(LAGER_NOKKEL, verdi); } catch (e) { /* privat modus */ }
  }
  function erPauset() {
    return document.documentElement.classList.contains('nf-bevegelse-av');
  }
  function tegnPauseknapp(knapp) {
    var pauset = erPauset();
    var tekst = knapp.querySelector('[data-nf-hero="pause-tekst"]');
    knapp.setAttribute('aria-pressed', pauset ? 'true' : 'false');
    knapp.setAttribute(
      'aria-label',
      pauset ? 'Spill av automatisk bevegelse' : 'Pause automatisk bevegelse'
    );
    if (tekst) tekst.textContent = pauset ? 'Spill av' : 'Pause';
  }
  function settPauset(pauset, skalLagre) {
    document.documentElement.classList.toggle('nf-bevegelse-av', pauset);
    if (skalLagre) lagre(pauset ? 'av' : 'pa');
    /* Slå opp knappene i DOM-en i stedet for å holde en liste — da blir
       det ingen referanser igjen til elementer editoren har byttet ut. */
    Array.prototype.forEach.call(
      document.querySelectorAll('[data-nf-hero="pause"]'),
      tegnPauseknapp
    );
  }
  /* Gjenopprett valget med én gang, også når heroen ikke er på siden */
  if (lagret() === 'av') settPauset(true, false);

  /* ---------- Hero ---------- */
  function initHero(rot) {
    if (!rot || rot.dataset.nfHeroInit) return;
    var lag = rot.querySelector('[data-nf-hero="lag"]');
    var prikker = rot.querySelector('[data-nf-hero="prikker"]');
    var kreditt = rot.querySelector('[data-nf-hero="kreditt"]');
    if (!lag || !prikker) return;

    var bilder = lag.querySelectorAll('img');
    if (!bilder.length) return;
    rot.dataset.nfHeroInit = '1';

    var intervall = parseInt(rot.dataset.nfHeroMs, 10) || 6000;
    var aktiv = 0;
    var auto = null;

    var knapper = [];
    Array.prototype.forEach.call(bilder, function (img, i) {
      var b = document.createElement('button');
      b.type = 'button';
      b.setAttribute('aria-label', img.dataset.nfNavn || 'Bilde ' + (i + 1));
      b.addEventListener('click', function () {
        vis(i);
        start();
      });
      prikker.appendChild(b);
      knapper.push(b);
    });

    function vis(i) {
      aktiv = i;
      Array.prototype.forEach.call(bilder, function (el, n) {
        if (n === i) {
          /* Bildet er usynlig her, så nullstillingen sees ikke — den lar
             Ken Burns starte forfra. */
          el.style.transform = '';
          el.className = 'pa';
          return;
        }
        if (el.className === 'pa') {
          /* Lås sluttposisjonen mens .pa fortsatt gjelder, ellers snapper
             bildet fra scale(1.1) til scale(1.02) midt i uttoningen. */
          el.style.transform = window.getComputedStyle(el).transform;
        }
        el.className = '';
      });
      knapper.forEach(function (el, n) {
        el.className = '';
        if (n === i) {
          void el.offsetWidth; /* tvinger omstart av fyll-animasjonen */
          el.className = 'pa';
        }
        el.setAttribute('aria-current', n === i ? 'true' : 'false');
      });
      if (kreditt) {
        var navn = bilder[i].dataset.nfNavn || '';
        /* Bildeteksten er en lenke til produktet. href byttes sammen med
           teksten — ellers ville den pekt paa foerste dekor for alltid. */
        var url = bilder[i].dataset.nfUrl || '';
        kreditt.style.opacity = 0;
        setTimeout(function () {
          kreditt.textContent = navn;
          if (url && kreditt.tagName === 'A') kreditt.setAttribute('href', url);
          kreditt.style.opacity = 1;
        }, 220);
      }
    }

    function stopp() {
      clearInterval(auto);
      auto = null;
    }

    function start() {
      /* Ingen automatisk rotasjon ved redusert bevegelse eller når
         brukeren har pauset — da bytter man selv med strekene. */
      stopp();
      if (rolig || erPauset() || bilder.length < 2) return;
      auto = setInterval(function () {
        vis((aktiv + 1) % bilder.length);
      }, intervall);
    }

    /* Rotasjonen står stille så lenge musen eller tastaturfokus er i
       heroen, slik at ingen mister et bilde de holder på å lese. */
    rot.addEventListener('mouseenter', stopp);
    rot.addEventListener('mouseleave', start);
    rot.addEventListener('focusin', stopp);
    rot.addEventListener('focusout', function (e) {
      if (!rot.contains(e.relatedTarget)) start();
    });

    /* Pause-/spill av-knappen */
    var pauseKnapp = rot.querySelector('[data-nf-hero="pause"]');
    if (pauseKnapp && !rolig) {
      pauseKnapp.addEventListener('click', function () {
        var pauset = !erPauset();
        settPauset(pauset, true);
        if (pauset) { stopp(); } else { start(); }
      });
      tegnPauseknapp(pauseKnapp);
      pauseKnapp.hidden = false;
    }

    vis(0);
    start();
  }

  /* ---------- Dekorstripen ----------
     Uendelig løkke i begge retninger. Posisjonen (x) eies av dette
     skriptet og skrives til en transform — ikke til scrollLeft. Det er
     hele poenget: med en scroll-container eier nettleseren treghets-
     animasjonen på touch, og å skrive posisjon midt i en fling rykker
     eller avbryter den. Her er innpakningen bare x modulo settbredden,
     og den er usynlig uansett når den inntreffer — under drag, under
     treghet eller under autorulling. Alle fire skriver til samme x. */
  function initStripe(rot) {
    if (!rot || rot.dataset.nfInit) return;
    var spor = rot.querySelector('[data-nf-mq="spor"]');
    var bane = rot.querySelector('[data-nf-mq="bane"]');
    if (!spor || !bane) return;
    var ekte = Array.prototype.slice.call(bane.children);
    if (!ekte.length) return;
    rot.dataset.nfInit = '1';

    var forrige = rot.querySelector('[data-nf-mq="forrige"]');
    var neste = rot.querySelector('[data-nf-mq="neste"]');

    var HASTIGHET = 26;      /* px per sekund */
    var HVILE = 4000;        /* ms uten aktivitet før autorullingen tas opp igjen */
    var DEMPING = 0.0028;    /* treghetens demping per ms */
    var STOPPFART = 0.004;   /* px/ms — under dette regnes tregheten som slutt */
    var MAKSFART = 2;        /* px/ms — tak, så en rask flikk ikke slynger stripen */

    var settbredde = 0;
    var x = 0;
    var fart = 0;            /* px/ms */
    var drar = false;
    var overtatt = false;
    var hviletimer = null;
    var sist = 0;
    var venter = 0;          /* oppsamlet dragbevegelse, skrives i ramme() */
    var levende = true;
    var iBevegelse = false;

    function bredden(el) {
      var st = window.getComputedStyle(el);
      return el.getBoundingClientRect().width + parseFloat(st.marginRight || 0);
    }
    function kortbredde() { return bredden(ekte[0]) || 188; }
    function maalSett() {
      var b = 0;
      ekte.forEach(function (el) { b += bredden(el); });
      return b;
    }

    /* Klon settet til banen dekker synsfeltet pluss ett helt sett, slik at
       det aldri oppstår et hull uansett hvor x står. Klonene er skjult for
       skjermlesere og utenfor tabrekkefølgen. */
    function fyll() {
      settbredde = maalSett();
      if (settbredde <= 0) return;
      Array.prototype.slice.call(bane.querySelectorAll('[data-nf-klon]'))
        .forEach(function (n) { n.parentNode.removeChild(n); });
      var bredde = settbredde;
      var trengs = settbredde + spor.clientWidth;
      var i = 0;
      var vakt = 0;
      /* Ett kort om gangen, ikke hele sett — laget blir bare så bredt som
         løkken faktisk krever. Rekkefølgen fortsetter mønsteret, så
         innpakningen modulo settbredden stemmer fortsatt. */
      while (bredde < trengs && vakt < 400) {
        var kilde = ekte[i % ekte.length];
        var k = kilde.cloneNode(true);
        k.setAttribute('data-nf-klon', '');
        k.setAttribute('aria-hidden', 'true');
        k.setAttribute('tabindex', '-1');
        Array.prototype.slice.call(k.querySelectorAll('a, button, input, select, [tabindex]'))
          .forEach(function (f) { f.setAttribute('tabindex', '-1'); });
        bane.appendChild(k);
        bredde += bredden(kilde);
        i++;
        vakt++;
      }
    }

    function tegn() { bane.style.transform = 'translate3d(' + x + 'px, 0, 0)'; }
    /* will-change tvinger et eget kompositørlag. Å la det stå permanent på
       en ~4500 px bred flate med 24 bilder koster GPU-minne kontinuerlig;
       det settes derfor bare mens stripen faktisk er i bevegelse. */
    function ibevegelse() {
      if (iBevegelse) return;
      iBevegelse = true;
      bane.style.willChange = 'transform';
    }
    function ihvile() {
      if (!iBevegelse) return;
      iBevegelse = false;
      bane.style.willChange = '';
    }
    function normaliser() {
      if (settbredde <= 0) return;
      /* Ren modulo — ingen terskel, ingen kant, ingenting å bomme på */
      while (x <= -settbredde) x += settbredde;
      while (x > 0) x -= settbredde;
    }
    function flytt(d) { x += d; normaliser(); tegn(); }

    function overta() {
      overtatt = true;
      window.clearTimeout(hviletimer);
      hviletimer = window.setTimeout(function () { overtatt = false; }, HVILE);
    }

    function ramme(t) {
      /* Løkken stopper av seg selv hvis seksjonen er byttet ut (theme-
         editoren), så en gammel løkke aldri blir liggende og gå. */
      if (!rot.isConnected) { levende = false; return; }
      if (!sist) sist = t;
      var dt = Math.min(t - sist, 50);
      sist = t;

      if (drar) {
        /* Draget skriver ikke posisjon selv — det samler opp bevegelsen,
           og her gjøres nøyaktig én skriving per frame. En mus med høy
           pollerate gir ellers 4–8 stilendringer per bilde. */
        if (venter !== 0) {
          flytt(venter);
          /* Farten måles per frame, ikke per hendelse: da blir dt et ekte
             tidsintervall i stedet for et tilfeldig lite tall. */
          fart = 0.7 * (venter / dt) + 0.3 * fart;
          if (fart > MAKSFART) fart = MAKSFART;
          if (fart < -MAKSFART) fart = -MAKSFART;
          venter = 0;
        }
      } else if (Math.abs(fart) > STOPPFART) {
        flytt(fart * dt);
        fart *= Math.exp(-DEMPING * dt);
        if (Math.abs(fart) <= STOPPFART) { fart = 0; ihvile(); }
      } else if (!overtatt && !rolig && !erPauset()) {
        ibevegelse();
        flytt(-(HASTIGHET / 1000) * dt);
      } else {
        ihvile();
      }
      window.requestAnimationFrame(ramme);
    }

    /* Myk forflytning for piltaster og pilknapper */
    function tween(delta) {
      if (rolig) { flytt(delta); return; }
      var t0 = null, gjort = 0;
      function steg(t) {
        if (!t0) t0 = t;
        var p = Math.min((t - t0) / 380, 1);
        var lettet = 1 - Math.pow(1 - p, 3);
        var maal = delta * lettet;
        flytt(maal - gjort);
        gjort = maal;
        if (p < 1) window.requestAnimationFrame(steg);
      }
      window.requestAnimationFrame(steg);
    }

    /* --- Drag med mus og berøring, med treghet etter slipp --- */
    var sisteX = 0, sisteT = 0, flyttetTot = 0, pekerId = null, fanget = false;
    spor.addEventListener('pointerdown', function (e) {
      if (e.pointerType === 'mouse' && e.button !== 0) return;
      drar = true;
      fart = 0;
      flyttetTot = 0;
      sisteX = e.clientX;
      sisteT = e.timeStamp || Date.now();
      spor.classList.add('drar');
      venter = 0;
      ibevegelse();
      /* Pekerfangsten settes IKKE her. Med fangst fra pointerdown gikk
         pointerup — og dermed click — til sporet i stedet for til <a>-en
         under pekeren, og ingen flis lot seg klikke: lenkene var ekte,
         fokus virket, tastaturet virket, men et museklikk navigerte aldri.
         Maalt 21. september: samme punkt, samme lenke, navigerte uten
         fangst og ikke med. Fangsten slaas paa i pointermove naar det
         faktisk er et drag — samme 6 px-terskel som click-vakten under. */
      pekerId = e.pointerId;
      fanget = false;
      overta();
    });
    /* Uten denne starter Chrome sin innebygde dra-og-slipp så snart man
       drar i et kort: lenker og bilder er draggable som standard, det
       vises et spøkelsesbilde, og nettleseren SLUTTER å levere
       pointermove til siden. Stripen fryser da midt i draget. */
    spor.addEventListener('dragstart', function (e) { e.preventDefault(); });

    spor.addEventListener('pointermove', function (e) {
      if (!drar) return;
      var d = e.clientX - sisteX;
      sisteX = e.clientX;
      flyttetTot += Math.abs(d);
      /* Under terskelen er det et klikk, ikke et drag, og sporet skal
         ikke roere seg. Foer flyttet 1–6 px sporet likevel — og ved
         innpakningsgrensen (x = 0, permanent med redusert bevegelse)
         pakket normaliser() om et helt sett mellom mousedown og mouseup,
         elementet under pekeren ble en klon, og klikket falt mellom to
         noder. Maalt 21. september. Samme 6 px som click-vakten under. */
      if (flyttetTot <= 6) return;
      /* Naa er det et drag: fang pekeren, saa bevegelsen leveres ogsaa
         naar den forlater sporet. */
      if (!fanget && spor.setPointerCapture) {
        try { spor.setPointerCapture(pekerId); fanget = true; } catch (err) { /* ignorer */ }
      }
      /* Bare oppsamling her — selve skrivingen skjer i ramme(), én gang
         per bilde. Summen er den samme, så draget følger pekeren 1:1. */
      venter += d;
      if (e.pointerType === 'mouse') e.preventDefault();
    });
    /* Paa window, ikke paa sporet. Uten fangst (under 6 px) gaar pointerup
       til elementet under pekeren — og slippes musa utenfor sporet, kom
       hendelsen aldri hit: drar ble staaende sann, autorullingen doede og
       sporet fulgte musa uten knapp nede. Reprodusert 21. september av tre
       uavhengige lesere. window faar hendelsen uansett hvor den slippes. */
    ['pointerup', 'pointercancel'].forEach(function (n) {
      window.addEventListener(n, function () {
        if (!drar) return;
        drar = false;
        /* Tøm siste oppsamling her, ikke i neste bilde. Et kjapt drag kan
           begynne og slutte innenfor ett bilde — da ville bevegelsen gått
           tapt, og farten aldri blitt regnet ut. */
        if (venter !== 0) {
          var naa = window.performance && window.performance.now
            ? window.performance.now() : Date.now();
          var dt = Math.max(naa - sist, 8);
          flytt(venter);
          fart = 0.7 * (venter / dt) + 0.3 * fart;
          if (fart > MAKSFART) fart = MAKSFART;
          if (fart < -MAKSFART) fart = -MAKSFART;
          venter = 0;
        }
        spor.classList.remove('drar');
        fanget = false;
        overta();
      });
    });
    /* Et drag skal ikke ende i at lenken under fingeren åpnes */
    spor.addEventListener('click', function (e) {
      /* e.detail er 0 for tastaturklikk (Enter/Space). Et touch-sveip gir
         aldri click, saa flyttetTot ble staaende, og neste Enter paa en
         flis ble svelget én gang. Tastaturet har ikke dratt i noe. */
      if (e.detail !== 0 && flyttetTot > 6) { e.preventDefault(); e.stopPropagation(); }
      flyttetTot = 0;
    }, true);

    /* --- Hjul og trackpad --- */
    spor.addEventListener('wheel', function (e) {
      var d = e.deltaX;
      if (!d && e.shiftKey) d = e.deltaY;
      if (!d) return;            /* rent loddrett: la siden rulle videre */
      overta();
      fart = 0;
      flytt(-d);
      e.preventDefault();
    }, { passive: false });

    /* --- Tastatur --- */
    spor.addEventListener('keydown', function (e) {
      if (e.target !== spor) return;
      if (e.key !== 'ArrowRight' && e.key !== 'ArrowLeft') return;
      overta();
      fart = 0;
      tween(e.key === 'ArrowRight' ? -kortbredde() : kortbredde());
      e.preventDefault();
    });

    /* Tabbing til et kort utenfor synsfeltet skal dra det inn */
    bane.addEventListener('focusin', function (e) {
      /* Chrome fokuserer <a> paa mousedown, og da fyrte denne og dro
         kortet inn i synsfeltet — sporet hoppet 72–81 px under pekeren,
         og naar kort 0 var kuttet i venstre kant pakket det om og klikket
         traff en klon. drar er satt av pointerdown foer fokus, saa den
         skiller mus fra Tab. Tab har drar usann og drar kortet inn som foer. */
      if (drar) return;
      var kort = e.target && e.target.closest ? e.target.closest('a') : null;
      if (!kort || kort.hasAttribute('data-nf-klon')) return;
      overta();
      var r = kort.getBoundingClientRect();
      var s = spor.getBoundingClientRect();
      if (r.left < s.left) flytt(s.left - r.left + 12);
      else if (r.right > s.right) flytt(s.right - r.right - 12);
    });

    /* --- Pilknappene: alltid synlige, det finnes ingen ender --- */
    function side() { return Math.max(spor.clientWidth - kortbredde() / 2, kortbredde()); }
    if (neste) neste.addEventListener('click', function () { overta(); fart = 0; tween(-side()); });
    if (forrige) forrige.addEventListener('click', function () { overta(); fart = 0; tween(side()); });

    window.addEventListener('resize', function () { fyll(); normaliser(); tegn(); });

    fyll();
    tegn();
    /* Bildene er late — bredden er først riktig når de har lastet */
    window.setTimeout(function () { fyll(); normaliser(); tegn(); }, 800);
    window.requestAnimationFrame(ramme);
  }

  /* ---------- Telleverk ---------- */
  function tellOpp(el) {
    var raa = (el.dataset.nfTall || '').trim();
    var des = parseInt(el.dataset.nfDes, 10) || 0;
    var suf = el.dataset.nfSuf || '';
    /* Norsk komma er den naturlige inntastingen i admin, og temaet skriver
       selv ut tall med komma. Normaliser den, og krev at hele verdien er
       et tall — ellers ville «23/33» blitt til 23. */
    var normalisert = raa.replace(/\s/g, '').replace(',', '.');
    var mal = /^-?\d+(\.\d+)?$/.test(normalisert) ? parseFloat(normalisert) : NaN;
    if (isNaN(mal)) {
      /* Ikke la markupens «0» bli stående — vis det som faktisk er skrevet. */
      el.textContent = raa + suf;
      return;
    }
    /* Kommaet får eget element fordi .tall gir det full sifferbredde i
       Schibsted Grotesk — se .nf-desimaltegn i nf-base.css. */
    var vis = function (v) {
      var s = v.toFixed(des).replace('.', ',');
      var i = s.indexOf(',');
      el.textContent = '';
      if (i === -1) {
        el.appendChild(document.createTextNode(s + suf));
        return;
      }
      el.appendChild(document.createTextNode(s.slice(0, i)));
      var komma = document.createElement('span');
      komma.className = 'nf-desimaltegn';
      komma.textContent = ',';
      el.appendChild(komma);
      el.appendChild(document.createTextNode(s.slice(i + 1) + suf));
    };
    if (rolig) {
      vis(mal);
      return;
    }
    var t0 = null;
    var ms = 900;
    function steg(t) {
      if (!t0) t0 = t;
      var p = Math.min((t - t0) / ms, 1);
      var e = 1 - Math.pow(1 - p, 3);
      vis(mal * e);
      if (p < 1) requestAnimationFrame(steg);
    }
    requestAnimationFrame(steg);
  }

  /* ---------- Avsløring ---------- */
  var obs = null;
  function avslor(el) {
    el.classList.add('inne');
    var t = el.matches('[data-nf-tall]') ? el : el.querySelector('[data-nf-tall]');
    if (t && !t.dataset.nfKjort) {
      t.dataset.nfKjort = '1';
      tellOpp(t);
    }
  }
  function observer(rot) {
    var elementer = (rot || document).querySelectorAll('.nf-avslor');
    if (!('IntersectionObserver' in window)) {
      Array.prototype.forEach.call(elementer, avslor);
      return;
    }
    if (!obs) {
      obs = new IntersectionObserver(function (poster) {
        poster.forEach(function (p) {
          if (!p.isIntersecting) return;
          avslor(p.target);
          obs.unobserve(p.target);
        });
      }, { threshold: 0.18 });
    }
    Array.prototype.forEach.call(elementer, function (el) {
      if (el.classList.contains('inne')) return;
      obs.observe(el);
    });
  }

  /* Tallbåndet (28. september): punktene er lenker til Guide. Får en av
     dem tastaturfokus, stopper båndet (nf-forside.css, :focus-within), og
     lenken rulles fram i båndets eget felt. Når fokus går ut av båndet,
     settes feltet tilbake, så løkken fortsetter fra start. Skriptet lastes
     av flere seksjoner; merket hindrer at lytterne legges på to ganger. */
  function initTicker(rot) {
    if (rot.hasAttribute('data-nf-ticker-klar')) return;
    rot.setAttribute('data-nf-ticker-klar', '');
    rot.addEventListener('focusin', function (e) {
      window.requestAnimationFrame(function () {
        e.target.scrollIntoView({ block: 'nearest', inline: 'nearest' });
      });
    });
    rot.addEventListener('focusout', function (e) {
      if (!rot.contains(e.relatedTarget)) rot.scrollLeft = 0;
    });
  }

  function boot(rot) {
    var heroer = (rot || document).querySelectorAll('[data-nf-hero="rot"]');
    Array.prototype.forEach.call(heroer, initHero);
    var baand = (rot || document).querySelectorAll('.nf-ticker');
    Array.prototype.forEach.call(baand, initTicker);
    var striper = (rot || document).querySelectorAll('[data-nf-mq="rot"]');
    Array.prototype.forEach.call(striper, initStripe);
    observer(rot);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () { boot(); });
  } else {
    boot();
  }

  /* Theme-editoren bytter ut seksjonens DOM ved re-render; init på nytt. */
  document.addEventListener('shopify:section:load', function (e) {
    boot(e.target);
  });
})();
